import React, { PureComponent } from "react";
import { withRouter } from "react-router-dom";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { Layout, Button, Result } from "antd";

class UnauthorizedPage extends PureComponent {
  constructor(props) {
    super(props);
  }

  goBack() {
    window.history.back();
  }
  render() {
    const { Content } = Layout;
    return (
      <Content>
        <Result
          status="403"
          title="403"
          subTitle="Sorry, you are not authorized to access this page."
          extra={
            <Button type="primary" onClick={this.goBack}>
              Back
            </Button>
          }
        />
        ,
      </Content>
    );
  }
}

export default withSharedStateConsumer(withRouter(UnauthorizedPage));
